import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs';
import {AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, NgZone, OnDestroy, OnInit} from '@angular/core';
import { DiagnosticOrderActionsService } from '@ispm/test/services/diagnostic-order-actions.service';
import { IDiagnosticOrder, IRevision } from '@ispm/test/interfaces/diagnostic-order.interface';
import { CoreActionCreatorService } from '@ispm/core/services/core-action-creator.service';
import { IWorkflowItem } from '@ispm/core/interfaces/workflow.interface';
import { ConfigurationStoreHandler } from '../../../configuration/services/configuration-store-handler.service';
import { IStepConfiguration } from '../../../configuration/interfaces/step-configuration.interface';
import { IConfigurationsMap, IDefinition } from '../../../configuration/interfaces/definition.interface';
import { IoptionElemet } from '@ispm/shared/interfaces/IoptionElemet';
import { DynamicModalLoaderService } from '@ispm/layout/services/dynamic-modal-loader.service';
import { PlaceholderModalComponent } from '@ispm/layout/components/modals/placeholder-modal/placeholder-modal.component';
import { DynamicSpecimenComponent } from '../sample-viewer/sample-list/sample-types/dynamic-specimen/dynamic-specimen.component';
import { TestActionsService } from '@ispm/test/services/test-actions.service';
import { modalResponse } from '@ispm/layout/constants/modal-responses.enum';
import { PlaceholderModalLoaderPayload } from '@ispm/layout/classes/placeholder-modal-loader-payload';
import { empty } from 'rxjs/observable/empty';
import { filter, flatMap, map, take } from 'rxjs/operators';
import { FormHandlerService } from '@ispm/dynamic-form/services/form-handler.service';
import { get, isEmpty } from 'lodash';
import { DynamicRequiredFieldsComponent } from "../sample-viewer/sample-list/sample-types/dynamic-required-fields/dynamic-required-fields.component";
import {NOTIFICATION_MESSAGE} from "@ispm-client/modules/aggregator/services/consts";
import {TestService} from '@ispm/dashboard/test/services/test.service';
import {WorkflowService} from '@ispm/workflow/services/workflow.service';
import {AuthenticationService} from '@ispm/user/services/authentication.service';
import {NotificationMessageService} from '@ispm/core/components/customise-notification/notifications-message.service';
import {ActivatedRoute, Router} from "@angular/router";
import {RouterManagerService} from "@ispm/core/services/router-manager.service";
import { PollJobService } from '@ispm/test/services/poll-job.service';

@Component({
  selector: 'gen-specimens-and-samples',
  templateUrl: './specimens-and-samples.component.html',
  styleUrls: ['./specimens-and-samples.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpecimensAndSamplesComponent implements OnInit, OnDestroy, AfterViewInit {
  private activeJob: IWorkflowItem;
  private readonly afterInitialResultsJobs = [
    'initialResults', 'postTrials', 'TherapyMatch', 'interpretationResults', 'none',
    'UiManualAberrationCuration', 'Final review'
  ];
  private testConfiguration$: Observable<IDefinition>;

  public createButtonText: string;
  public proceedToAnalysisButtonText: string;
  public proceedToAnalysisDisabled: boolean;
  public isAssignee: boolean;
  public formsOverrides: any = { };
  public destroyer$: Subject<any> = new Subject();
  public newItemOptions: any[] = [];

  currentStepConfiguration$: Observable<IStepConfiguration<IConfigurationsMap>>;
  formsConfig: any[];
  QMSValues: any;
  isEditableField: boolean;
  currentOrder: IDiagnosticOrder;
  currentRevision: IRevision;
  editableFields = {
    specimen: []
  };
  testConfiguration;
  markAsPrimaryEnabled: boolean;
  inputs: any[];
  revisionId: string;
  testId: string;
  userId: string;
  loaded: boolean = false;

  constructor(
    private testActionsService: TestActionsService,
    private modalLoader: DynamicModalLoaderService,
    private diagnosticOrderActionsService: DiagnosticOrderActionsService,
    private testService : TestService,
    private notificationMessageService: NotificationMessageService,
    private notificationMessage: NOTIFICATION_MESSAGE,
    private TestService : TestService,
    private authService: AuthenticationService,
    private workflowService: WorkflowService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private coreActions: CoreActionCreatorService,
    private _ngZone: NgZone,
    private _diagnosticOrderActionsService: DiagnosticOrderActionsService,
    configurationStoreHandler: ConfigurationStoreHandler,
    private _cd: ChangeDetectorRef,
    private _formHandlerService: FormHandlerService,
    private routerManagerService: RouterManagerService,
    private pollJobService: PollJobService,
  ) {
    this.currentStepConfiguration$ = configurationStoreHandler.getConfigurationForCurrentStep();
    this.testConfiguration$ = configurationStoreHandler.getCurrentConfig();
    this.proceedToAnalysisDisabled = true;
  }

  ngOnInit() {
    this.revisionId = this.activatedRoute.parent.snapshot.params.revisionId;
    this.testId = this.activatedRoute.parent.snapshot.params.testId;
    this.userId = this.authService.user.info.id;
    this.createButtonText = 'add specimen';
    this.proceedToAnalysisButtonText = 'Proceed to analysis';

    const testConfiguration = this.testService.testConfiguration;

    if (testConfiguration) {
      this.QMSValues = testConfiguration.QMSValues;
      this.formsConfig = Array.isArray(testConfiguration.formsConfig) ? testConfiguration.formsConfig : [];
      this.testConfiguration = testConfiguration;
    }

    this.markAsPrimaryEnabled = this.testConfiguration.specimensTabConfig
      && this.testConfiguration.specimensTabConfig.markAsPrimaryEnabled
      && this.testConfiguration.specimensTabConfig.markAsPrimaryEnabled === true
    ;

    if (!this.formsConfig.some(item => item.key === '')) {
      const dynamicBasicForm = { key: '', title: '', formId: 'BASIC-TEST-DATA-DEFAULT'};
      this.formsConfig.unshift(dynamicBasicForm);
    }

    this.diagnosticOrderActionsService.getState()
      .filter(state => !!state.order && Object.keys(state.order).length > 0)
      .take(1)
      .map(state => state.order)
      .subscribe(current => {
        this.currentOrder = current;
        current.specimen.forEach((spec, index) => {
          this.editableFields.specimen[index] = {
            type: false,
            collection: false,
            tumorPercentage: false,
            tumorGrade: false,
            collectedDateTime: false,
            receivedTime: false,
            IHCStatus: false
          };
        });
        this.currentRevision = this.currentOrder.workflowRequest.revisions.find(rev => rev.id === this.revisionId);
        this.activeJob = this.currentRevision.items.find(item => item.name === this.currentOrder.workflowRequest.activeJobName);

        if (this.activeJob) {
          this.inputs = this.activeJob['inputs'];
        }

        const statusIsAfterInitialResults = !this.activeJob || this.afterInitialResultsJobs.some(
          job => job.toLowerCase() === this.activeJob.name.toLowerCase())
        ;
        this.isAssignee = this.currentOrder.performer === this.userId;

        this.currentStepConfiguration$.take(1).subscribe(async(currentStepConfiguration) => {
          let editable = null;

          if(await this.isStepConfigAvailable()) {
            this.formsOverrides = FormHandlerService.BuildOverrides(currentStepConfiguration);
            if (currentStepConfiguration &&
              currentStepConfiguration.fieldsValidation &&
              currentStepConfiguration.fieldsValidation.hasOwnProperty('isEditable')) {

              editable = currentStepConfiguration.fieldsValidation.isEditable;
            }
          }
          if (editable === null) {
            editable = !statusIsAfterInitialResults && !testConfiguration.uneditableFields;
          }

          this.isEditableField = editable && this.isAssignee;
          this.loaded = true;
          this._cd.markForCheck();
          this._cd.detectChanges();
          this.updateRequiredFields(this.currentOrder.specimen);
        });
      });



    this.setSpecimenCreateOptions();
  }

  ngAfterViewInit() {
    this.coreActions.setLoader(false);
  }

  private  isFieldRequiredForNonPrimarySpecimen() : boolean{
    return this.currentOrder.specimen.filter(s => s.isPrimary).length != 2
  }

  private async isStepConfigAvailable() {
    const testConfig = await this.testConfiguration$.pipe(take(1)).toPromise();

    return get(testConfig, 'specimensTabConfig.stepConfiguration', false);
  }

  ngOnDestroy(): void {
    this.destroyer$.next();
    this.destroyer$.complete();
  }

  setSpecimenCreateOptions(): void {
    if (this.currentOrder.specimen) {
      if(this.testConfiguration.specimensTabConfig.twoPrimarySpecimensRequired){
        this.proceedToAnalysisDisabled = this.currentOrder.specimen.filter(s=>s.isPrimary).length != 2;
      }
      else {
        for (const specimen of this.currentOrder.specimen) {
          if (specimen.isPrimary === true) {
            this.proceedToAnalysisDisabled = false;
          }
        }
      }
    }



    this.newItemOptions = [];

    for (const specimenConfig of this.testConfiguration.specimenConfig) {
      const newItemOption = { };
      newItemOption['label'] = specimenConfig.sampleType;
      newItemOption['command'] = () => {
        this.loadForm(specimenConfig.formId, specimenConfig.title,
          {
            sampleType: specimenConfig.sampleType,
            specimenType: specimenConfig.specimenType,
            inputs: []
          });
      };
      this.newItemOptions.push(newItemOption);
    }
  }

  public loadForm(formName, titleText: string, itemData: { sampleType: string, specimenType: string, inputs: IoptionElemet[] }) {
    const createData = this.getSpecimenCreationData(itemData, formName);
    this.modalLoader.popupModal(
      PlaceholderModalComponent,
      new PlaceholderModalLoaderPayload(
        `Add ${titleText}`,
        createData.createComp,
        'Save',
        'Cancel',
        createData['payload']
      )
    ).pipe(
      take(1),
      filter(response => response.payload),
      map(response => response.payload))
      .subscribe((response: any) => {
        switch (<modalResponse> response.status) {
          case modalResponse.approve:
            this.coreActions.setLoader(true);
            return this.testActionsService.AddSpecimen(
              response.payload.sample,
              this.testId,
              this.testService.testConfiguration.limsWorkflowId,
              this.revisionId,
              this.testService.testConfiguration.id,
              true,
              response.payload.sample.isFieldsRequired
            )
              .pipe(take(1))
              .subscribe( ()=>{
                this._ngZone.runOutsideAngular(() => {
                  this.coreActions.setLoader(false);
                  this.routerManagerService.reload();
                });
              })

          case modalResponse.decline:
          default:
            return empty();
        }
      })
  }

  getSpecimenCreationData(itemData: { sampleType: string, specimenType: string; inputs: IoptionElemet[] }, formName: string) {
    const payload = {
      testId: this.testId,
      revisionId: this.revisionId,
      formName: formName,
      formId: formName,
      orderId: this.currentOrder.id,
      options: itemData.inputs,
      sampleType: itemData.sampleType,
      specimenType: itemData.specimenType,
      popupMode: true,
      overrides: get(this.formsOverrides, formName),
      isFieldsRequired: this.isFieldRequiredForNonPrimarySpecimen()
    };

    return { createComp: DynamicSpecimenComponent, payload: payload};
  }

  async emitUpdate($event: { specimen: any, primaryTumor: any}) {
    this.updateRequiredFields($event.specimen);
    this.currentOrder.specimen = $event.specimen;
    this.currentOrder['primaryTumor'] = $event.primaryTumor;
    this.diagnosticOrderActionsService.setDiagnosticOrder(this.currentOrder);
    this.setSpecimenCreateOptions();
    this.coreActions.setLoader(false);
  }

  private updateRequiredFields(specimens: any[]) {
    if (specimens.filter(s => s.isPrimary).length == 2) {
      for (const specimen of specimens) {
        if (specimen.isPrimary == false) {
          specimen.isFieldsRequired = false;
        } else {
          specimen.isFieldsRequired = undefined;
        }
      }
    }
  }

  async proceedToAnalysis() {
    let validationResult = await this.validateSpecimens();
    if(this.isSpecimensNotValid(validationResult)){
      this.popupSpcimensValidationPopup(validationResult);
    }
    else{
      await this.performWorkflowStep(['testInfoReview'], 'testInfoReview');
    }
  }

  private popupSpcimensValidationPopup(validationResult){
    this.modalLoader.popupModal(
      PlaceholderModalComponent,
      new PlaceholderModalLoaderPayload(
        'Required information for test info is missing',
        DynamicRequiredFieldsComponent,
        'OK',
        null,
        validationResult
      )
    )
  }

  private isSpecimensNotValid(validationResult){
    return validationResult.missingInformationBySampleType.size > 0;
  }

  private async validateSpecimens(){
    let popupPayload = {
      missingInformationBySampleType: null
    };

    popupPayload.missingInformationBySampleType = await this.getRequiredMissingInformationFields();

    return popupPayload;
  }

  private async getRequiredMissingInformationFields() {
    const testConfig = await this.testConfiguration$.pipe(take(1)).toPromise();
    const requiredTestInfoFields = this.testConfiguration.requiredTestInfoFields.find(s => s.attributeName === 'specimen');

    const sampleTypeSet = new Map<string, Set<any>>()

    for (const specimenConfig of testConfig.specimenConfig) {
      this._formHandlerService.getForm(specimenConfig.formId).subscribe(form => {
        for (const speciman of this.currentOrder.specimen.filter( s=> s.isPrimary)) {
          const specimanWithConfig = speciman as any;
          if (specimanWithConfig.config.formId === form.id) {
            let relevantInputs = form.inputs.filter(i =>
              requiredTestInfoFields.fields.filter(r => r.attributeName === i.name).length > 0);
            let emptyInputs = relevantInputs.filter(ri => isEmpty(get(speciman, ri.name)));
            emptyInputs.forEach(ei => {
              if (!sampleTypeSet.has(speciman.sampleType)) {
                sampleTypeSet.set(speciman.sampleType, new Set());
              }
              sampleTypeSet.get(speciman.sampleType).add(ei);
            });
          }
        }
      })
    }
    return sampleTypeSet;
  }

  private async performWorkflowStep(requiredActiveSteps: string[], stepToPerform: string, inputButtonArgs?: any): Promise<void> {
    if (requiredActiveSteps.some(this.isActiveStep)) {
      this.coreActions.setLoader(true);
      const workflowId = this.currentOrder.workflowRequest.id;
      return this.workflowService.performWorkflowStep(this.currentOrder, stepToPerform, null, this.revisionId, null, null, inputButtonArgs,false)
        .then(() => this.pollJobService.waitForWorkflowCondition(workflowId, this.currentRevision.id,
            workflow => workflow.activeJobName !== this.currentOrder.workflowRequest.activeJobName, 2000, 20)
        )
        .then(workflow => {
          if (workflow.activeJobName.toLowerCase().includes('fail')) {
            throw new Error('Can\'t perform workflow step');
          }
          this.notificationMessageService.success(this.notificationMessage.SUCCESSFULLY_MOVED_TO_NEXT_STEP);
          this.routerManagerService.reload();
        }).catch(() => {
          this.notificationMessageService.error(this.notificationMessage.UNABLE_TO_MOVE_TO_THE_NEXT_STEP);
        })
        .finally(() => this.coreActions.setLoader(false));
    }
  }

  isActiveStep = (stepName: string): boolean => {
    stepName = stepName.toLowerCase();
    let isActiveStep = false;
    const isJobActive = this.activeJob && this.activeJob.name.toLowerCase() === stepName;
    const isTestStatusNotDone = this.currentOrder.workflowRequest.status.toLowerCase() !== 'done';
    const isTestNotCompleted = this.currentRevision.status.toLowerCase() !== 'test completed';

    switch (stepName) {
      case 'reviewtestresults':
      case '2ndopinionrequested':
      case '2ndopinionreview':
      case 'initialresults':
      case 'testinforeview':
      case 'interpretationresults':
        isActiveStep = isJobActive && isTestNotCompleted && isTestStatusNotDone;
        break;
      case 'uigeneralinput':
      case 'reviewqcresults':
      case 'pipelinefailed':
        isActiveStep = this.activeJob && this.activeJob.name.toLowerCase().includes(stepName) && isTestNotCompleted && isTestStatusNotDone;
        break;
      case 'final review':
        isActiveStep = isJobActive && isTestNotCompleted && isTestStatusNotDone;
        break;
      case 'testcompleted':
        isActiveStep = !isTestNotCompleted;
        break;
    }

    return isActiveStep;
  }
}
